import { ChangeDetectionStrategy, Component, input, model, Optional } from '@angular/core';
import { CustomField, CustomFieldDetail } from '@pedix-workspace/utils';
import { TranslocoDirective } from '@ngneat/transloco';
import { UntilDestroy } from '@ngneat/until-destroy';
import { CustomFieldComponent } from '../../custom-field/custom-field.component';
import { ControlContainer, FormsModule, NgForm } from '@angular/forms';

@UntilDestroy()
@Component({
  selector: 'pxw-end-order-custom-fields',
  templateUrl: './end-order-custom-fields.component.html',
  styleUrls: ['./end-order-custom-fields.component.scss'],
  providers: [],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoDirective, CustomFieldComponent, FormsModule],
  viewProviders: [
    {
      provide: ControlContainer,
      deps: [[Optional, NgForm]],
      useFactory: (ngForm: NgForm) => ngForm,
    },
  ],
})
export class EndOrderCustomFieldsComponent {
  readonly customFields = input.required<CustomField[]>();
  readonly isFormSubmitted = input<boolean>(false);

  readonly customFieldDetailValues = model.required<CustomFieldDetail['value'][]>();

  onUpdateCustomFieldDetailValue(index: number, value: CustomFieldDetail['value']) {
    this.customFieldDetailValues.update(customFieldDetailValues =>
      Object.assign([], customFieldDetailValues, {
        [index]: value,
      }),
    );
  }
}
